import { PhoneFieldClass } from '../../components/phone-fields/descope-phone-field/PhoneFieldClass';
import { refs } from './inputWrapper';

const vars = PhoneFieldClass.cssVarList;

const phoneField = {
  [vars.hostWidth]: refs.width,
  [vars.hostDirection]: refs.direction,
  [vars.fontSize]: refs.fontSize,
  [vars.fontFamily]: refs.fontFamily,
  [vars.labelTextColor]: refs.labelTextColor,
  [vars.labelRequiredIndicator]: refs.requiredIndicator,
  [vars.errorMessageTextColor]: refs.errorMessageTextColor,
  [vars.inputValueTextColor]: refs.valueTextColor,
  [vars.inputPlaceholderTextColor]: refs.placeholderTextColor,
  [vars.inputBorderStyle]: refs.borderStyle,
  [vars.inputBorderWidth]: refs.borderWidth,
  [vars.inputBorderColor]: refs.borderColor,
  [vars.inputBorderRadius]: refs.borderRadius,
  [vars.inputOutlineStyle]: refs.outlineStyle,
  [vars.inputOutlineWidth]: refs.outlineWidth,
  [vars.inputOutlineColor]: refs.outlineColor,
  [vars.inputOutlineOffset]: refs.outlineOffset,
  [vars.phoneInputWidth]: refs.minWidth,
  [vars.countryCodeInputWidth]: '5em',
  [vars.countryCodeDropdownWidth]: '20em',
  [vars.marginInlineStart]: '-0.25em',
  [vars.valueInputHeight]: refs.valueInputHeight,
  [vars.valueInputMarginBottom]: refs.valueInputMarginBottom,

  // error message icon
  [vars.errorMessageIcon]: refs.errorMessageIcon,
  [vars.errorMessageIconSize]: refs.errorMessageIconSize,
  [vars.errorMessageIconPadding]: refs.errorMessageIconPadding,
  [vars.errorMessageIconRepeat]: refs.errorMessageIconRepeat,
  [vars.errorMessageIconPosition]: refs.errorMessageIconPosition,
  [vars.errorMessageFontSize]: refs.errorMessageFontSize,

  // '@overlay': {
  // 	overlayItemBackgroundColor: 'red'
  // }
};

export default phoneField;
export { vars };
